/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import authApi from 'apis/authApi'
import userApi from 'apis/userApi'
import { configs, constants, links, MESSAGE } from 'apps'
import messages from 'apps/messages'
import { METAMASK_LOGIN_BTN, TOKENPOCKET_LOGIN_BTN } from 'assets/images'
import classNames from 'classnames'
import { setAuthState } from 'features/Auth/auth.slice'
import ConnectH2hModal from 'features/Profile/components/ConnectH2Hmodal'
import { setCurrentUser } from 'features/Profile/profile.slice'
import { ResultHorseModal } from 'features/Race/components'
import ConfirmOkModal from 'features/Race/components/ConfirmOkModal'
import { useAppDispatch, useAppSelector, useLocalStorage, useReloadCurrentPage, useToggle } from 'hooks'
import { NOTIFICATION_MESSAGE } from 'i18n/constants'
import { AuthState, PostLoginError } from 'models'
import { useTranslation } from 'react-i18next'
import { TwoLineTitle } from 'shared'
import { handleAsyncRequest } from 'utils/helper'
import {
  getBalance,
  getCurrentUser,
  getPostLoginBody,
  getRandomMessage,
  getSignerByProvider,
  isRequestAccountsError
} from 'utils/metamask'
import AuthStyled from './styled'
import { useAvailableWallet } from './useAvailableWallet'
import { EIP6963ProviderDetail } from './types'

function Auth() {
  const providers = useAvailableWallet()
  const [errorMessage, setErrorMessage] = useState<string>('')
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [accessToken, setAccessToken] = useLocalStorage(constants.ACCESS_TOKEN_KEY, null)
  const [, setRefreshToken] = useLocalStorage(constants.REFRESH_TOKEN_KEY, null)
  const [, setStorageUserId] = useLocalStorage(constants.USER_ID_KEY, 0)
  const dispatch = useAppDispatch()
  const auth = useAppSelector(state => state.auth)
  const navigate = useNavigate()
  const [openConnectH2hModal, setOpenConnectH2hModal] = useToggle(false)
  const [isSyncHorseModal, toggleSyncHorseModal] = useToggle(false)
  const [valueFirstWebLogin, setValueFirstWebLogin] = useState<boolean>(false)
  const [firstLoginH2H, setFirstLoginH2H] = useState<boolean>(false)
  const [flagMetamask, setFlagMetamask] = useState<boolean>(false)
  const [flagTokenPocket, setFlagTokenPocket] = useState<boolean>(false)
  const [isModalResultHorseOpen, toggleIsModalResultHorseOpen] = useToggle(false)
  const { t } = useTranslation()
  const metaMaskButtonClass = classNames('login-btn', 'p-0', { ['login-btn--loading']: isLoading })
  const handleCloseModalResult = () => {
    toggleIsModalResultHorseOpen(false)
    setFlagMetamask(false)
    setFlagTokenPocket(false)
  }
  const flagClickLogin = localStorage.getItem('clickLogin') as any

  useEffect(() => {
    if (flagClickLogin === true) {
      setIsLoading(false)
    }
  }, [flagClickLogin])

  const fetchSyncHorse = async () => {
    await handleAsyncRequest(userApi.getSyncHorse({ loginFlag: 1 }))
    if (valueFirstWebLogin === true) {
      setOpenConnectH2hModal(true)
      return
    }
    navigate(links.home.index())
    window.location.reload()
  }

  useEffect(() => {
    if (accessToken) {
      toggleSyncHorseModal(true)
    }
  }, [auth, valueFirstWebLogin])

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const isPostLoginError = (candidate: any): candidate is PostLoginError => {
    const isValid: boolean =
      candidate.code === constants.HTTP_STATUS.BAD_REQUEST && typeof candidate.message === 'string'

    return isValid
  }

  const handleOk = () => {
    toggleIsModalResultHorseOpen(false)
    setFlagMetamask(false)
    setFlagTokenPocket(false)
  }

  // const handleMetamaskLoginClicked = async (hexId: string | null) => {
  //   if (isLoading) return

  //   flagClickLogin === false && setIsLoading(true)
  //   if (!isEthereumWalletInstalled()) {
  //     toggleIsModalResultHorseOpen(true)
  //     setFlagMetamask(true)
  //   }
  //   const chainID = parseInt(String(hexId), 16)
  //   if (chainID) {
  //     if (checkCurrentNetwork()) {
  //       localStorage.removeItem(constants.CLICKLOGIN)
  //       const [signerError, signer] = await handleAsyncRequest(getSigner())
  //       if (signerError && isRequestAccountsError(signerError)) {
  //         // -32002: Already processing eth_requestAccounts. Please wait.
  //         // 4001: user declined the request
  //         window.ethereum.request({
  //           method: 'wallet_requestPermissions',
  //           params: [
  //             {
  //               eth_accounts: {}
  //             }
  //           ]
  //         })
  //         setErrorMessage(messages.please_login_metamask)
  //         return
  //       }
  //       if (!signer) return

  //       const [, randomMessage] = await handleAsyncRequest(getRandomMessage())
  //       if (!randomMessage) return

  //       const [loginError, postLoginBody] = await handleAsyncRequest(getPostLoginBody(signer, randomMessage))

  //       if (loginError && isRequestAccountsError(loginError)) {
  //         setIsLoading(false)
  //         return
  //       }

  //       if (!postLoginBody) return

  //       const [postLoginError, loginResponse] = await handleAsyncRequest(authApi.postLogin(postLoginBody))
  //       if (postLoginError && isPostLoginError(postLoginError)) {
  //         setErrorMessage(postLoginError.message)
  //       }
  //       if (!loginResponse) return
  //       const {
  //         data: { access_token, refresh_token, user_id }
  //       } = loginResponse

  //       setAccessToken(access_token)
  //       setRefreshToken(refresh_token)
  //       setStorageUserId(user_id)

  //       const [, currentUser] = await handleAsyncRequest(getCurrentUser())
  //       if (!currentUser) return

  //       const [, result] = await handleAsyncRequest(userApi.getUserInformation())
  //       if (!result) return ''
  //       if (result.data.first_web_login === true && result.data.h2h_id === null) {
  //         // setOpenConnectH2hModal(true)
  //         setValueFirstWebLogin(true)
  //         setFirstLoginH2H(true)
  //       }

  //       const [, balance] = await handleAsyncRequest(getBalance(signer))
  //       if (typeof balance !== 'string') return

  //       const valueMARE = balance.split(',').shift()
  //       const valueEMAS = balance.split(',').pop()

  //       const authState: AuthState = {
  //         user_id,
  //         isLogged: true,
  //         isFirstLogin: true,
  //         balance: {
  //           coinMare: valueMARE,
  //           coinEmas: valueEMAS
  //         }
  //       }

  //       dispatch(setAuthState(authState))
  //       dispatch(setCurrentUser(currentUser))
  //     } else {
  //       // toggleIsModalResultHorseOpen(true)
  //       try {
  //         await window.ethereum.request({
  //           method: 'wallet_addEthereumChain',
  //           params: [
  //             {
  //               chainId: configs.chainIdDirect,
  //               rpcUrls: [configs.linkRpcUrls],
  //               chainName: configs.nameChain,
  //               nativeCurrency: {
  //                 name: configs.nameCurrency,
  //                 symbol: configs.nameCurrency,
  //                 decimals: +configs.valueDecimals
  //               },
  //               blockExplorerUrls: [configs.linkBlockExplorerUrls]
  //             }
  //           ]
  //         })
  //       } catch (addError) {
  //         console.log(addError, 'addError')
  //       }
  //     }
  //     // setIsLoading(false)
  //   } else {
  //     // useReloadCurrentPage()
  //   }
  // }

  const handleCancelConnectH2hModal = () => {
    setOpenConnectH2hModal(false)
  }

  const handleConnectLater = () => {
    navigate(links.home.index())
  }

  const handleCloseSyncHorse = () => {
    if (valueFirstWebLogin === true) {
      setOpenConnectH2hModal(true)
      return
    }
    navigate(links.home.index())
    window.location.reload()
  }

  const handleConnect = async (providerWithInfo: EIP6963ProviderDetail) => {
    const accounts: string[] | undefined = (await providerWithInfo.provider
      .request({ method: 'eth_requestAccounts' })
      .catch(console.error)) as string[] | undefined
    if (accounts?.[0]) {
      localStorage.setItem('walletName', providerWithInfo.info?.name)
      if (providerWithInfo.info?.name === 'MetaMask') {
        if (isLoading) return

        flagClickLogin === false && setIsLoading(true)
        if (!providerWithInfo.provider) {
          toggleIsModalResultHorseOpen(true)
          setFlagMetamask(true)
        }
        const ethereum = providerWithInfo.provider
        const chainID = await ethereum.request({
          method: 'eth_chainId',
        }) ?? ''
        if (chainID) {
          if (String(parseInt(chainID as string, 16)) === String(configs.chainId)) {
            localStorage.removeItem(constants.CLICKLOGIN)
            const [signerError, signer] = await handleAsyncRequest(getSignerByProvider(ethereum))
            if (signerError && isRequestAccountsError(signerError)) {
              console.log(signerError, '---signerError')
              // -32002: Already processing eth_requestAccounts. Please wait.
              // 4001: user declined the request
              ethereum.request({
                method: 'wallet_requestPermissions',
                params: [
                  {
                    eth_accounts: {}
                  }
                ]
              })
              setErrorMessage(messages.please_login_metamask)
              return
            }
            if (!signer) return

            const [, randomMessage] = await handleAsyncRequest(getRandomMessage())
            if (!randomMessage) return

            const [loginError, postLoginBody] = await handleAsyncRequest(getPostLoginBody(signer, randomMessage))

            if (loginError && isRequestAccountsError(loginError)) {
              setIsLoading(false)
              return
            }

            if (!postLoginBody) return

            const [postLoginError, loginResponse] = await handleAsyncRequest(authApi.postLogin(postLoginBody))
            if (postLoginError && isPostLoginError(postLoginError)) {
              setErrorMessage(postLoginError.message)
            }
            if (!loginResponse) return
            const {
              data: { access_token, refresh_token, user_id }
            } = loginResponse

            setAccessToken(access_token)
            setRefreshToken(refresh_token)
            setStorageUserId(user_id)

            const [, currentUser] = await handleAsyncRequest(getCurrentUser())
            if (!currentUser) return

            const [, result] = await handleAsyncRequest(userApi.getUserInformation())
            if (!result) return ''
            if (result.data.first_web_login === true && result.data.h2h_id === null) {
              // setOpenConnectH2hModal(true)
              setValueFirstWebLogin(true)
              setFirstLoginH2H(true)
            }

            const [, balance] = await handleAsyncRequest(getBalance(signer))
            if (typeof balance !== 'string') return

            const valueMARE = balance.split(',').shift()
            const valueEMAS = balance.split(',').pop()

            const authState: AuthState = {
              user_id,
              isLogged: true,
              isFirstLogin: true,
              balance: {
                coinMare: valueMARE,
                coinEmas: valueEMAS
              }
            }

            dispatch(setAuthState(authState))
            dispatch(setCurrentUser(currentUser))
            localStorage.setItem('walletAddress', accounts?.[0])
          } else {
            // toggleIsModalResultHorseOpen(true)
            try {
              await ethereum.request({
                method: 'wallet_addEthereumChain',
                params: [
                  {
                    chainId: configs.chainIdDirect,
                    rpcUrls: [configs.linkRpcUrls],
                    chainName: configs.nameChain,
                    nativeCurrency: {
                      name: configs.nameCurrency,
                      symbol: configs.nameCurrency,
                      decimals: +configs.valueDecimals
                    },
                    blockExplorerUrls: [configs.linkBlockExplorerUrls]
                  }
                ]
              })
            } catch (addError) {
              console.log(addError, 'addError')
            }
          }
          setIsLoading(false)
        } else {
          useReloadCurrentPage()
        }
      }
      if (providerWithInfo.info?.name === 'TokenPocket') {
        if (isLoading) return
        flagClickLogin === false && setIsLoading(true)
        if (!providerWithInfo.provider) {
          toggleIsModalResultHorseOpen(true)
          setFlagTokenPocket(true)
        }
        const ethereum = providerWithInfo.provider
        const chainID = parseInt(ethereum.chainId as string, 16) ?? ''
        if (chainID) {
          if (String(chainID) === String(configs.chainId)) {
            localStorage.removeItem(constants.CLICKLOGIN)
            const [signerError, signer] = await handleAsyncRequest(getSignerByProvider(ethereum))
            if (signerError && isRequestAccountsError(signerError)) {
              ethereum.request({
                method: 'wallet_requestPermissions',
                params: [
                  {
                    eth_accounts: {}
                  }
                ]
              })
              setErrorMessage(messages.please_login_token_pocket)
              return
            }
            if (!signer) return

            const [, randomMessage] = await handleAsyncRequest(getRandomMessage())
            if (!randomMessage) return

            const [loginError, postLoginBody] = await handleAsyncRequest(getPostLoginBody(signer, randomMessage))

            if (loginError && isRequestAccountsError(loginError)) {
              setIsLoading(false)
              return
            }

            if (!postLoginBody) return

            const [postLoginError, loginResponse] = await handleAsyncRequest(authApi.postLogin(postLoginBody))
            if (postLoginError && isPostLoginError(postLoginError)) {
              setErrorMessage(postLoginError.message)
            }
            if (!loginResponse) return
            const {
              data: { access_token, refresh_token, user_id }
            } = loginResponse

            setAccessToken(access_token)
            setRefreshToken(refresh_token)
            setStorageUserId(user_id)

            const [, currentUser] = await handleAsyncRequest(getCurrentUser())
            if (!currentUser) return

            const [, result] = await handleAsyncRequest(userApi.getUserInformation())
            if (!result) return ''
            if (result.data.first_web_login === true && result.data.h2h_id === null) {
              setValueFirstWebLogin(true)
              setFirstLoginH2H(true)
            }

            const [, balance] = await handleAsyncRequest(getBalance(signer))
            if (typeof balance !== 'string') return

            const valueMARE = balance.split(',').shift()
            const valueEMAS = balance.split(',').pop()

            const authState: AuthState = {
              user_id,
              isLogged: true,
              isFirstLogin: true,
              balance: {
                coinMare: valueMARE,
                coinEmas: valueEMAS
              }
            }

            dispatch(setAuthState(authState))
            dispatch(setCurrentUser(currentUser))
            localStorage.setItem('walletAddress', accounts?.[0])
          } else {
            try {
              await ethereum.request({
                method: 'wallet_addEthereumChain',
                params: [
                  {
                    chainId: configs.chainIdDirect,
                    rpcUrls: [configs.linkRpcUrls],
                    chainName: configs.nameChain,
                    nativeCurrency: {
                      name: configs.nameCurrency,
                      symbol: configs.nameCurrency,
                      decimals: +configs.valueDecimals
                    },
                    blockExplorerUrls: [configs.linkBlockExplorerUrls]
                  }
                ]
              })
            } catch (addError) {
              console.log(addError, 'addError')
            }
          }
          setIsLoading(false)
        } else {
          useReloadCurrentPage()
        }
      }
    }
  }

  const checkWallet = (walletType: string) => () => {
    const myProvider = providers.find((prov) => prov.info?.name === walletType) ?? undefined
    if (!myProvider) {
      if (walletType === 'MetaMask') {
        setFlagMetamask(true)
      } else {
        setFlagTokenPocket(true)
      }
      toggleIsModalResultHorseOpen(true)
    } else {
      handleConnect(myProvider)
    }
  }

  return (
    <AuthStyled>
      <div className='login'>
        <div className='container'>
          <div className='title-container d-flex flex-column align-items-center'>
            <TwoLineTitle text={t(`${NOTIFICATION_MESSAGE}.joinNow`)} customClass='title' />
            <div className='sub-title color-white'>{t(`${NOTIFICATION_MESSAGE}.careerMarkName`)}</div>
          </div>
          <div className='login-container'>
            <div className='login-wrapper d-flex flex-column flex-md-row justify-content-center align-items-center'>
              <button
                className={metaMaskButtonClass}
                onClick={checkWallet('MetaMask')}
              >
                <img src={METAMASK_LOGIN_BTN} alt='' className={isLoading ? '' : 'login-img'} />
              </button>
              <button
                className={metaMaskButtonClass}
                onClick={checkWallet('TokenPocket')}
              >
                <img src={TOKENPOCKET_LOGIN_BTN} alt='' className={isLoading ? '' : 'login-img'} />
              </button>
            </div>
          </div>
          <div className='err-container color-red text-center'>{errorMessage}</div>
        </div>
      </div>
      {openConnectH2hModal && valueFirstWebLogin === true && (
        <ConnectH2hModal
          firstLoginH2H={firstLoginH2H}
          toggleIsModalOpen={setOpenConnectH2hModal}
          onCancelModal={handleCancelConnectH2hModal}
          onConnectLater={handleConnectLater}
        />
      )}
      {isModalResultHorseOpen && (
        <ResultHorseModal
          title={'warning'}
          onCloseButtonClick={handleCloseModalResult}
          onOk={handleOk}
          message={flagMetamask ? MESSAGE.please_install_metamask : flagTokenPocket ? MESSAGE.please_install_token_pocket : MESSAGE.please_install_spectre}
        />
      )}

      {isSyncHorseModal && (
        <ConfirmOkModal
          onCloseButtonClick={handleCloseSyncHorse}
          onConfirm={fetchSyncHorse}
          message={
            <div className='font-size-18'>
              <div dangerouslySetInnerHTML={{ __html: t(`${NOTIFICATION_MESSAGE}.syncHorseNow`) }} />
            </div>
          }
          title='Warning'
        />
      )}
    </AuthStyled>
  )
}

export default Auth
